import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import ImagePreview from '@/components/ImagePreview.vue';
import InvoicePlain from '@/components/InvoicePlain.vue';
import Modal from '../components/Modal.vue';
import Daterangepicker from '../components/Daterangepicker.vue';
import Overview from '../components/Overview.vue';
import PriceDisplay from '../components/PriceDisplay.vue';
import WalletHistoryDetails from '../components/WalletHistoryDetails.vue';
import MutationValue from '../components/MutationValue.vue';
import BillingDetails from '../components/BillingDetails.vue';
import ModalPaymentConfirmation from '@/components/ModalPaymentConfirmation.vue';
import BillingPaymentModal from '@/components/BillingPaymentModal.vue';
import {
	duplicateVar,
	getDateRange,
	downloadFile,
	getAxiosErrorMessage,
	formatNumberPlain,
	formatMoney,
	makePDF,
	copyToClipboard,
	showMidtransSnap,
	delay,
} from '@/lib/helper';
import {
	shippingCouriers,
	enabledCouriers,
	ostockBankAccount,
} from '@/lib/statics';
import fileApi from '@/api/file';
import billingsApi from '@/api/billings';


const defaultFilterDate = getDateRange();
const defaultSelectedType = { key: 'all', label: 'Type' };
const defaultSelectedCourier = { key: 'all', label: 'Courier' };
const defaultSelectedStatus = { key: 'all', label: 'Status' };

export default {
	name: 'Billings',
	props: {
		mode: {
			type: String,
			default: 'user',
		},
	},
	components: {
		Modal,
		Daterangepicker,
		Overview,
		PriceDisplay,
		WalletHistoryDetails,
		MutationValue,
		ImagePreview,
		BillingDetails,
		InvoicePlain,
		ModalPaymentConfirmation,
		BillingPaymentModal,
	},
	data() {
		return {
			keyword: '',
			limit: 25,
			page: 1,
			sort_by: 'billing_id',
			sort: 'desc',
			billings: [],
			selected: null,
			isFetching: false,
			isFetchingStats: false,
			isAll: false,
			filterDate: defaultFilterDate,
			isExporting: false,
			currency: 'Rp',
			isFetchingOutstandings: false,
			outstandings: 0,
			stats: 0,
			bankAccount: null,
			isConfirmVisible: false,
			file: null,
			fileUrl: '',
			isConfirming: false,
			isRouteChecked: false,
			isInvoiceVisible: false,
			isPrinting: false,
			userEmail: '',
			typeOptions: [
				{ key: 'all', label: 'All' },
				{ key: 'subscription', label: 'Subscription' },
				{ key: 'full_payment', label: 'Full Payment' },
				{ key: 'invoicing', label: 'Invoicing' },
				{ key: 'rts_product_cost', label: 'Return Shipping Product Cost' },
				{ key: 'shipping_cost', label: 'Shipping Cost' },
				{ key: 'rts_shipping_cost', label: 'RTS Shipping Cost' },
				{ key: 'other', label: 'Other' },
			],
			selectedType: duplicateVar(defaultSelectedType),
			isRtsType: false,
			selectedCourier: defaultSelectedCourier,
			statusOptions: [
				{ key: 'all', label: 'All' },
				{ key: 'unpaid', label: 'Unpaid' },
				{ key: 'verifying', label: 'Verifying' },
				{ key: 'paid', label: 'Paid' },
				{ key: 'cancelled', label: 'Cancelled' },
			],
			selectedStatus: defaultSelectedStatus,
			isUploading: false,
			isCancelVisible: false,
			isRemoveVisible: false,
			selectedBilling: null,
			isGeneratingToken: false,
			paymentChecker: null,
			isShowModalPaymentConfirmation: false,
			isCancelSubVisible: false,
			isCancelling: false,
			billingId: '',
			isFilterVisible: false,
			paidAtSince: '',
			paidAtUntil: '',
			isDueDateVisible: false,
			dueDateEdit: '',
			isUpdatingDueDate: false,
			isEditValueVisible: false,
			isUpdatingValue: false,
			selectedCheckBox: [],
			selectedBillings: [],
			isSubmitting: false,
			paymentMode: 'single',
			initFinished: false,
			isBillingPaymentModalVisible: false,
			isCreatingSubscriptionBilling: false,
		};
	},
	methods: {
		...mapActions({
		}),
		createNewSubscriptionBilling() {
			this.isCreatingSubscriptionBilling = true;
			const params = {
				package: 'personal_2',
				package_duration: 1,
			};
			const callback = () => {
				this.isCreatingSubscriptionBilling = false;
				this.$notify({
					group: 'app',
					title: 'Subscription',
					text: 'Tagihan subscription berhasil dibuat.',
					type: 'success',
				});
				this.fetch(true);
			};
			const errorCallback = (error) => {
				this.isCreatingSubscriptionBilling = false;
				const message = getAxiosErrorMessage(error) || 'Gagal membuat tagihan subscription.';
				this.$notify({
					group: 'app',
					title: 'Subscription',
					text: message,
					type: 'error',
				});
			};
			billingsApi.generateSubscription(params, callback, errorCallback);
		},
		reset() {
			this.billings = [];
			this.isAll = false;
			this.page = 1;
		},
		fetch(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.reset();
			}
			const params = this.getFetchParams();
			const callback = (response) => {
				const billings = response.data;
				billings.forEach((billing) => {
					this.billings.push(billing);
				});
				this.page++;
				if (billings.length < this.limit) {
					this.isAll = true;
				}
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
				this.isAll = true;
			};

			if (this.isAdminMode) {
				billingsApi.getAll(params, callback, errorCallback);
			} else {
				billingsApi.getList(params, callback, errorCallback);
			}

			// this.getTotal();
		},
		exportBillings() {
			this.isExporting = true;
			const params = this.getFetchParams();
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			billingsApi.exportBillings(params, callback, errorCallback);
		},
		init() {
			if (this.initFinished) return;
			this.initFinished = true;
			this.checkCapabilities();
			this.initFilterDate();
			this.getOutstandings();
			this.setStatus();
			this.fetch();
			this.getTotal();
		},
		setStatus() {
			if (this.queryStatus && this.queryStatus !== '') {
				const selectedStatus = this.statusOptions.find(item => item.key === this.queryStatus);
				this.selectedStatus = selectedStatus;
			} else if (this.isAdminMode) {
				this.statusOptions.push({ key: 'pending', label: 'Pending ' });
				this.selectedStatus = { key: 'verifying', label: 'Verifying' };
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = dayjs(filterDate.start).format('YYYY-MM-DD');
			const until = dayjs(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetch(true);
			this.getTotal();
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetch();
				self.getTotal();
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetch(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetch(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		checkCapabilities() {
			// if ((!this.isOwner && !this.isUserCan('billings_view')) || !this.isAdmin) {
			if (!this.isAdminMode && !this.isOwner && !this.isUserCan('billings_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		formatDate(dateString, format = 'DD-MM-YYYY - HH:mm') {
			const timezone = this.user.timezone;
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const format = 'YYYY-MM-DD';
				const since = dayjs(this.since).format(format);
				const until = dayjs(this.until).format(format);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		getMemberName(id) {
			const member = this.members.find(member => member._id === id);
			return member ? member.name : '';
		},
		getFetchParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const status = this.selectedStatus ? this.selectedStatus.key : 'verify';
			const type = this.selectedType ? this.selectedType.key : 'all';
			const courier = this.selectedCourier ? this.selectedCourier.key : 'all';

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: startDate,
				until: endDate,
			};

			if (status !== 'all') {
				params.status = status;
			}

			if (type !== 'all') {
				params.type = type;
			}

			const keyword = this.keyword.trim();
			if (keyword && keyword !== '') {
				params.keyword = keyword;
			}

			if ((type === 'rts_shipping_cost' || type === 'shipping_cost') && courier !== 'all') {
				params.info = `courier_${courier}`;
			}

			const billingId = this.billingId.trim();
			if (billingId && billingId !== '') {
				params.billing_id = parseInt(billingId);
			}

			const paidSince = this.paidAtSince;
			if (paidSince && paidSince !== '') {
				params.paid_at_since = paidSince;
			}

			const paidUntil = this.paidAtUntil;
			if (paidUntil && paidUntil !== '') {
				params.paid_at_until = paidUntil;
			}

			const userEmail = this.userEmail ? this.userEmail.trim() : '';
			if (userEmail && userEmail !== '') {
				params.user_email = userEmail;
			}

			return params;
		},
		getFetchTotalParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const type = this.selectedType ? this.selectedType.key : 'all';
			const courier = this.selectedCourier ? this.selectedCourier.key : 'all';
			const status = this.selectedStatus ? this.selectedStatus.key : 'all';
			const params = {
				since: startDate,
				until: endDate,
			};

			if (type !== 'all') {
				params.type = type;
			}

			if ((type === 'rts_shipping_cost' || type === 'shipping_cost') && courier !== 'all') {
				params.courier = courier;
			}

			if (status !== 'all') {
				params.status = status;
			}

			const billingId = this.billingId.trim();
			if (billingId && billingId !== '') {
				params.billing_id = parseInt(billingId);
			}

			const paidSince = this.paidAtSince;
			if (paidSince && paidSince !== '') {
				params.paid_at_since = paidSince;
			}

			const paidUntil = this.paidAtUntil;
			if (paidUntil && paidUntil !== '') {
				params.paid_at_until = paidUntil;
			}

			const userEmail = this.userEmail ? this.userEmail.trim() : '';
			if (userEmail && userEmail !== '') {
				params.user_email = userEmail;
			}

			return params;
		},
		getOutstandings() {
			this.isFetchingOutstandings = true;
			const callback = (response) => {
				const outstandings = response.data;
				this.outstandings = outstandings;
				this.isFetchingOutstandings = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Billings',
					text: message,
				});
				this.isFetchingOutstandings = false;
			};
			if (this.isAdminMode) {
				billingsApi.getAllOutstandings(callback, errorCallback);
			} else {
				billingsApi.getOutstandings(callback, errorCallback);
			}
		},
		getTotal() {
			this.isFetchingStats = true;
			const params = this.getFetchTotalParams();
			const callback = (response) => {
				if (response.data && response.data.totalAmount) {
					const stats = response.data.totalAmount;
					this.stats = stats;
				} else {
					this.stats = 0;
				}
				this.isFetchingStats = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Billings',
					text: message,
				});
				this.isFetchingStats = false;
			};
			if (this.isAdminMode) {
				billingsApi.getAllTotal(params, callback, errorCallback);
			} else {
				billingsApi.getTotal(params, callback, errorCallback);
			}
		},
		exportHistory() {
			this.isExporting = true;
			const dateFormat = 'YYYY-MM-DD';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const params = {
				sort_by: this.sort_by,
				sort: this.sort,
				since: startDate,
				until: endDate,
			};
			const callback = (response) => {
				this.isExporting = false;
				// const file = response.data;
				// const files = file.split('/');
				// const fileDir = `${files[0]}/${files[1]}`;
				// const fileName = files[2];
				// const fileNameEncoded = encodeURIComponent(fileName);
				// const path = `${fileDir}/${fileNameEncoded}`;
				// const prefix = 'https://api.ostock.id';
				// const url = `${prefix}/${path}`;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			billingsApi.export(params, callback, errorCallback);
		},
		formatNumber(number) {
			return formatNumberPlain(number);
		},
		showDetails(billing) {
			if (this.selected && this.selected.id === billing.id) {
				this.selected = null;
				return;
			}
			this.selected = duplicateVar(billing);
		},
		update(billing) {
			const index = this.billings.findIndex(({ _id }) => _id === billing._id);
			if (index !== -1) {
				const currentBilling = duplicateVar(this.billings[index]);
				const updatedBilling = Object.assign({}, currentBilling, billing);
				this.$set(this.billings, index, updatedBilling);
			}
		},
		showConfirmation(billing) {
			const privateOrderData = billing?.data?.private_order ?? undefined;
			const privateOrderId = privateOrderData?._id?.$oid ?? privateOrderData?._id;
			const isPaymentMethodBankTransfer = billing?.payment?.method === 'bank_transfer';
			if (!this.isAdmin && privateOrderId && isPaymentMethodBankTransfer) {
				this.$router.push({
					name: 'payment-confirmation',
					query: {
						pid: privateOrderId,
					},
				});
				return;
			}

			this.selected = billing;
			this.file = null;
			this.fileUrl = '';
			this.isConfirmVisible = true;
		},
		showPaymentConfirmation(billing) {
			this.selected = billing;
			this.isShowModalPaymentConfirmation = true;
		},
		closeConfirmation() {
			this.isConfirmVisible = false;
			this.selected = null;
		},
		closeCancel() {
			this.isCancelVisible = false;
			this.selected = null;
		},
		onSelectFile(event) {
			const files = event.target.files;
			if (files.length > 0) {
				const file = files[0];
				this.file = file;
				this.uploadFile(file);
			}
		},
		uploadFile(file) {
			this.isUploading = true;
			const username = this.user.username;
			const formData = new FormData();
			formData.append('file', file);
			formData.append('username', username);

			const callback = (response) => {
				const path = response.data;
				const url = `https://cdn.orderonline.id/${path}`;
				this.fileUrl = url;
				this.isUploading = false;
			};
			const errorCallback = () => {
				this.isUploading = false;
			};
			fileApi.upload(formData, callback, errorCallback);
		},
		confirm() {
			this.isConfirming = true;
			const id = this.selected._id;
			let params = {};

			if (this.isAdminMode) {
				params = {
					status: 'paid',
				};
			} else {
				params = {
					payment_receipt: this.fileUrl,
				};
			}

			const callback = (response) => {
				const billing = response.data;
				const message = response.message;
				this.update(billing);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Billing Confirmation',
					text: message,
				});
				this.isConfirming = false;
				this.isConfirmVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Billing Confirmation',
					text: message,
				});
				this.isConfirming = false;
			};
			if (this.isAdminMode) {
				billingsApi.verifyPayment(id, callback, errorCallback);
			} else {
				billingsApi.confirm(id, params, callback, errorCallback);
			}
		},
		showCancelConfirmation(billing) {
			this.selected = billing;
			this.isCancelVisible = true;
		},
		showRemoveConfirmation(billing) {
			this.selected = billing;
			this.isRemoveVisible = true;
		},
		cancelBillingConfirmation() {
			this.isConfirming = true;
			const id = this.selected._id;

			const params = {
				status: 'unpaid',
				payment_receipt: '',
			};

			const callback = (response) => {
				const billing = response.data;
				const message = response.message;
				this.update(billing);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Cancel Billing',
					text: message,
				});
				this.isConfirming = false;
				this.isCancelVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Cancel Billing',
					text: message,
				});
				this.isConfirming = false;
			};

			billingsApi.update(id, params, callback, errorCallback);
		},
		showCancelSubscription(billing) {
			this.selected = billing;
			this.isCancelSubVisible = true;
		},
		cancelSubscriptionBilling() {
			this.isCancelling = true;
			const id = this.selected._id;

			const callback = (response) => {
				const billing = response.data;
				const message = response.message;
				this.update(billing);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Cancel Subscription',
					text: message,
				});
				this.isCancelling = false;
				this.isCancelSubVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Cancel Subscription',
					text: message,
				});
				this.isCancelling = false;
			};

			if (this.isAdminMode) {
				const params = {
					status: 'cancelled',
				};
				billingsApi.update(id, params, callback, errorCallback);
			} else {
				billingsApi.cancelSubscription(id, callback, errorCallback);
			}
		},
		dueDate(date) {
			return dayjs(date)
				.add(7, 'days')
				.format('DD-MM-YYYY');
		},
		exportDetails(billing) {
			this.isExporting = true;
			this.selected = billing;
			const params = {
				billing_id: billing.billing_id,
				// user_id: '',
			};
			const callback = (response) => {
				const url = response.data;
				downloadFile(url);
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			if (!this.isAdminMode) {
				billingsApi.exportDetails(params, callback, errorCallback);
			} else {
				params.user_id = billing.user_id;
				billingsApi.exportDetailsByAdmin(params, callback, errorCallback);
			}
		},
		hideInvoice() {
			this.isInvoiceVisible = false;
			this.selected = null;
		},
		showInvoice(billing) {
			this.selected = billing;
			this.isInvoiceVisible = true;
		},
		printInvoice() {
			this.isPrinting = true;
			const billingId = this.selected.billing_id;
			const timestamp = new Date().getTime();
			const name = `Billing-Invoice-${billingId}-${timestamp}`;
			const callback = () => {
				this.isPrinting = false;
			};
			setTimeout(() => {
				makePDF(document, 'invoice', html2canvas, jsPDF, name, callback);
			}, 300);
		},
		getStatusColor(status) {
			let color = 'danger';
			if (status === 'paid') {
				color = 'success';
			} else if (status === 'verifying') {
				color = 'warning';
			} else if (status === 'cancelled') {
				color = 'disabled';
			}
			return color;
		},
		copy(text) {
			copyToClipboard(text);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'copied to clipboard',
			});
		},
		onTypeChange(option) {
			if (option.key === 'rts_shipping_cost') {
				this.isRtsType = true;
			} else {
				this.isRtsType = false;
			}

			this.selectedType = option;
			this.applyFilter();
		},
		onCourierChange(option) {
			this.selectedCourier = option;
			this.applyFilter();
		},
		onStatusChange(option) {
			this.selectedStatus = option;
			this.applyFilter();
		},
		onBillingIdChange() {
			delay(() => {
				this.applyFilter();
			}, 500);
		},
		applyFilter() {
			const selectedType = this.selectedType;
			let selectedCourier = this.selectedCourier;
			const selectedStatus = this.selectedStatus;
			const query = duplicateVar(this.$route.query);

			// type
			if (
				selectedType
				&& selectedType !== null
				&& selectedType !== ''
				&& selectedType.key !== 'all'
			) {
				query.type = selectedType.key;
				this.selectedType = selectedType;
			} else {
				delete query.type;
				this.selectedType = defaultSelectedType;

				delete query.courier;
				this.selectedCourier = defaultSelectedCourier;
				selectedCourier = defaultSelectedCourier;
			}

			// courier
			if (
				selectedCourier
				&& selectedCourier !== null
				&& selectedCourier !== ''
				&& selectedCourier.key !== 'all'
			) {
				query.courier = selectedCourier.key;
				this.selectedCourier = selectedCourier;
			} else {
				delete query.courier;
				this.selectedCourier = defaultSelectedCourier;
			}

			// status
			if (
				selectedStatus
				&& selectedStatus !== null
				&& selectedStatus !== ''
				&& selectedStatus.key !== 'all'
			) {
				query.status = selectedStatus.key;
				this.selectedStatus = selectedStatus;
			} else {
				delete query.status;
				this.selectedStatus = defaultSelectedStatus;
			}

			// Paid Since
			const paidSince = this.paidAtSince;
			if (paidSince && paidSince !== '') {
				query.paid_at_since = paidSince;
			} else {
				delete query.paid_at_since;
			}

			// Paid Until
			const paidUntil = this.paidAtUntil;
			if (paidUntil && paidUntil !== '') {
				query.paid_at_until = paidUntil;
			} else {
				delete query.paid_at_until;
			}

			// User Email
			const userEmail = this.userEmail ? this.userEmail.trim() : '';
			if (userEmail && userEmail !== '') {
				query.user_email = userEmail;
			} else {
				delete query.user_email;
			}

			const params = { path: document.location.pathname, query };
			this.$router.push(params);

			this.fetch(true);
			this.getTotal();

			this.isFilterVisible = false;
		},
		clearFilter() {
			this.paidAtSince = '';
			this.paidAtUntil = '';
			this.userEmail = '';
		},
		setAsPaid() {
			if (this.paymentMode === 'single' && this.selectedBilling) {
				const index = this.billings.findIndex(({ _id }) => _id === this.selectedBilling._id);
				if (index !== -1) {
					const billing = this.billings[index];
					billing.status = 'paid';
					this.$set(this.billings, index, billing);
				}
			}

			if (this.paymentMode === 'group' && this.selectedCheckBox) {
				this.selectedCheckBox.forEach((id) => {
					const index = this.billings.findIndex(({ _id }) => _id === id);
					if (index !== -1) {
						const billing = this.billings[index];
						billing.status = 'paid';
						this.$set(this.billings, index, billing);
					}
				});
			}
		},
		midtransCallback(status, result) {
			console.log(result);
			if (status === 'success') {
				console.log(status, result);
				this.setAsPaid();
				if (this.paymentChecker) {
					clearInterval(this.paymentChecker);
				}
			} else if (status === 'pending') {
				const pdfUrl = result.pdf_url;
				window.open(pdfUrl, '_blank');
			} else if (status === 'error') {
				console.log(status);
			} else if (status === 'close') {
				console.log(status);
				if (this.paymentChecker) {
					clearInterval(this.paymentChecker);
				}
			}
		},
		generateToken(billing) {
			this.selectedBilling = billing;
			this.paymentMode = 'single';
			this.isBillingPaymentModalVisible = true;
		},
		closeBillingPaymentModal() {
			this.isBillingPaymentModalVisible = false;
			this.selectedBilling = null;
		},
		handlePaymentSuccess(token) {
			this.isBillingPaymentModalVisible = false;
			showMidtransSnap(token, this.midtransCallback);
			this.startPaymentChecker(this.selectedBilling._id);
		},
		handlePaymentSuccessGroup({ token, id }) {
			this.isBillingPaymentModalVisible = false;
			showMidtransSnap(token, this.midtransCallback);
			this.startPaymentCheckerGroup(id);
		},
		startPaymentChecker(id) {
			const statusChecker = () => {
				const callback = (response) => {
					const status = response.data;
					if (status === 'paid') {
						this.setAsPaid();
						if (window.snap) {
							window.snap.hide();
						}
						clearInterval(this.paymentChecker);
					}
				};
				const errorCallback = () => {
				};
				billingsApi.getStatus(id, callback, errorCallback);
			};
			this.paymentChecker = setInterval(statusChecker, 2000);
		},
		changeDueDate(billing) {
			this.selectedBilling = billing;
			let billingDueDate = billing.due_date;
			billingDueDate = dayjs(billingDueDate).format('YYYY-MM-DD');
			this.dueDateEdit = billingDueDate;

			this.isDueDateVisible = true;
		},
		updateDueDate() {
			this.isUpdatingDueDate = true;
			const billingId = this.selectedBilling._id;
			const params = {
				due_date: this.dueDateEdit,
			};
			const callback = (response) => {
				const updatedBilling = response.data;
				this.update(updatedBilling);
				this.isUpdatingDueDate = false;
				this.isDueDateVisible = false;
			};
			const errorCallback = () => {
				this.isUpdatingDueDate = false;
			};
			billingsApi.updateDueDate(billingId, params, callback, errorCallback);
		},
		closeDueDate() {
			this.isDueDateVisible = false;
			this.selectedBilling = null;
		},
		editValue(billing) {
			this.selectedBilling = billing;
			const value = billing.value;
			this.valueEdit = value;

			this.isEditValueVisible = true;
		},
		updateValue() {
			this.isUpdatingDueDate = true;
			const billingId = this.selectedBilling._id;
			const value = parseInt(this.valueEdit);
			const params = {
				value,
			};
			const callback = (response) => {
				const updatedBilling = response.data;
				this.update(updatedBilling);
				this.isUpdatingDueDate = false;
				this.isEditValueVisible = false;
			};
			const errorCallback = () => {
				this.isEditValueVisible = false;
			};
			billingsApi.updateValue(billingId, params, callback, errorCallback);
		},
		closeEditValue() {
			this.isEditValueVisible = false;
			this.selectedBilling = null;
		},
		handleBillingCheck(billing, event) {
			const isChecked = event.target.checked;
			const index = this.selectedBillings.findIndex(
				currSub => currSub._id === billing._id,
			);
			if (isChecked && index === -1) {
				this.selectedBillings.push(billing);
			} else if (!isChecked && index !== -1) {
				this.selectedBillings.splice(index, 1);
			}
		},
		isBillingPayable(billing) {
			return billing.status !== 'cancelled' && billing.status !== 'paid' && billing.payment?.method === 'instant';
		},
		bulkPay() {
			this.paymentMode = 'group';
			this.isBillingPaymentModalVisible = true;
		},
		startPaymentCheckerGroup(id) {
			const statusChecker = () => {
				const callback = (response) => {
					const status = response.data;
					if (status === 'paid') {
						this.setAsPaid();
						if (window.snap) {
							window.snap.hide();
						}
						clearInterval(this.paymentChecker);
					}
				};
				const errorCallback = () => {
				};
				billingsApi.getStatusGroup(id, callback, errorCallback);
			};
			this.paymentChecker = setInterval(statusChecker, 2000);
		},
		generatePaymentMethod(billing) {
			const data = {
				key: null,
				label: '-',
			};

			const payment = billing?.payment;
			if (!payment) return data;

			if (payment?.method === 'instant') {
				data.key = 'instant';
				data.label = this.$t('Instant');
			} else if (payment?.method === 'bank_transfer') {
				data.key = 'bank_transfer';
				data.label = this.$t('Bank Transfer');
			}

			return data;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isSupport: 'isSupport',
			bankAccounts: 'bankAccounts',
			presetRangeLabel: 'presetRangeLabel',
			filterDatePresets: 'filterDatePresets',
			isHasFeature: 'isHasFeature',
			isUserCan: 'isUserCan',
			members: 'members/all',
			isExpired: 'isExpired',
			isSupplier: 'isSupplier',
		}),
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		outstandingsDisplay() {
			return formatMoney(this.outstandings);
		},
		isAdminMode() {
			return this.mode === 'admin' && (this.isAdmin || this.isHasFeature('admin_billings'));
		},
		isCanConfirm() {
			return this.isOwner || this.isUserCan('billings_confirm');
		},
		nonCancelledBillings() {
			return this.billings.filter(billing => billing.status !== 'cancelled');
		},
		invoiceItems() {
			let items = [];
			if (this.selected) {
				if (this.selected.items && this.selected.items.length > 0) {
					items = duplicateVar(this.selected.items);
				} else {
					items = [
						{
							name: this.selected.description,
							price: this.selected.value,
							quantity: 1,
						},
					];
				}

				// If there's a payment fee in data.payment_details, append it
				const paymentDetails = this.selected.data?.payment_details;
				if (paymentDetails && paymentDetails.fee > 0) {
					let methodName = 'Virtual Account';
					if (paymentDetails.method === 'gopay' || paymentDetails.method === 'qris' || paymentDetails.method === 'other_qris') {
						methodName = 'QRIS';
					}
					items.push({
						name: `Biaya Transaksi (${methodName})`,
						quantity: 1,
						price: paymentDetails.fee,
					});
				}
			}
			return items;
		},
		status() {
			const status = this.selectedStatus ? this.selectedStatus.key : 'all';
			return status;
		},
		queryType() {
			const type = this.$route.query.type;
			return type;
		},
		queryCourier() {
			const courier = this.$route.query.courier;
			return courier;
		},
		queryStatus() {
			const status = this.$route.query.status;
			return status;
		},
		queryPaidSince() {
			const paidAtSince = this.$route.query.paid_at_since;
			return paidAtSince;
		},
		queryPaidUntil() {
			const paidAtUntil = this.$route.query.paid_at_until;
			return paidAtUntil;
		},
		queryUserEmail() {
			const userEmail = this.$route.query.user_email;
			return userEmail;
		},
		unpaidBillings() {
			return this.billings.filter(({ status }) => status === 'unpaid');
		},
		couriersOptions() {
			const enabled = enabledCouriers;
			const couriers = shippingCouriers.filter(({ key }) => enabled.includes(key));
			couriers.unshift({ key: 'all', label: 'All Couriers' });
			return couriers;
		},
		isCanComplete() {
			return this.isAdmin || this.isHasFeature('admin_billings');
		},
		bankAccounts() {
			const accounts = duplicateVar([ostockBankAccount]);
			return accounts;
		},
		isCourierFilterVisible() {
			let isVisible = false;
			if (this.selectedType) {
				const selectedType = this.selectedType;
				isVisible = selectedType.key === 'shipping_cost' || selectedType.key === 'rts_shipping_cost';
			}
			return isVisible;
		},
		unpaidSubscriptionBillings() {
			return this.billings.filter(({ status, type }) => status === 'unpaid' && type === 'subscription');
		},
		selectAll: {
			get() {
				const allBilling = duplicateVar(this.billings);
				const payableBillings = allBilling.filter(billing => this.isBillingPayable(billing));
				return payableBillings
					? this.selectedCheckBox.length === payableBillings.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.billings.forEach((billing) => {
						if (this.isBillingPayable(billing)) {
							selected.push(billing._id);
						}
					});
					const allBilling = duplicateVar(this.billings);
					this.selectedBillings = allBilling.filter(billing => this.isBillingPayable(billing));
				} else {
					this.selectedBillings = [];
				}
				this.selectedCheckBox = selected;
			},
		},
		userStore() {
			const userStore = duplicateVar(this.user.store);
			const userDetail = {
				...userStore,
			};

			if (this.isAdminMode) {
				console.log(userDetail);
				userDetail.name = this.selected?.name ?? '-';
				userDetail.email = this.selected?.email ?? '-';
				userDetail.phone = this.selected?.phone ?? '-';
			} else {
				if (userDetail.name === undefined || userDetail.name === '') {
					userDetail.name = this.user.name;
				}

				if (userDetail.email === undefined || userDetail.email === '') {
					userDetail.email = this.user.email;
				}

				if (userDetail.phone === undefined || userDetail.phone === '') {
					userDetail.phone = this.user.phone;
				}
			}

			return userDetail;
		},
	},
	watch: {
		user: {
			handler() {
				this.init();
			},
		},
	},
	mounted() {
		if (this.user) {
			this.init();
		}
	},
	created() {
		if (this.queryType && this.queryType !== '') {
			const selectedType = this.typeOptions.find(item => item.key === this.queryType);
			this.selectedType = selectedType;

			if (selectedType.key === 'rts_shipping_cost') {
				this.isRtsType = true;
			} else {
				this.isRtsType = false;
			}
		}

		if (this.queryCourier && this.queryCourier !== '') {
			const selectedCourier = this.couriersOptions.find(item => item.key === this.queryCourier);
			this.selectedCourier = selectedCourier;
		}

		if (this.queryStatus && this.queryStatus !== '') {
			const selectedStatus = this.statusOptions.find(item => item.key === this.queryStatus);
			this.selectedStatus = selectedStatus;
		}

		if (this.queryPaidSince && this.queryPaidSince !== '') {
			this.paidAtSince = this.queryPaidSince;
		}

		if (this.queryPaidUntil && this.queryPaidUntil !== '') {
			this.paidAtUntil = this.queryPaidUntil;
		}

		if (this.queryUserEmail && this.queryUserEmail !== '') {
			this.userEmail = this.queryUserEmail;
		}

		window.addEventListener('scroll', this.handleScroll);
		document.addEventListener('scroll', this.onDocumentScroll, true);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('scroll', this.onDocumentScroll, true);
	},
};
